module.exports = __webpack_public_path__ + "img/tag2.eb4360df.png";